import { render } from "./LastDataPreview.vue?vue&type=template&id=c68f5e22&ts=true"
import script from "./LastDataPreview.vue?vue&type=script&lang=ts"
export * from "./LastDataPreview.vue?vue&type=script&lang=ts"

import "./LastDataPreview.vue?vue&type=style&index=0&id=c68f5e22&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__